import { memo } from 'react';
import { BiTrash } from 'react-icons/bi';
import { FiUserPlus } from 'react-icons/fi';
import useFollow from '../../../../hooks/useFollow';
import { IPendingFollowMe } from '../../../../interfaces/components/profileElement.interface';
import { useModal } from '../../../../state/modal-provider/ModalProvider';

const PendingFollowMe: React.FC<IPendingFollowMe> = ({
  data,
  uid,
  refectAfterChangeInformation,
}) => {
  const { toast } = useModal();

  const { acceptFollow } = useFollow();

  return (
    <div className="bg-transparent sm:mb-[-80px] sm:py-3 pb-3 w-full border-b-2 border-dashed">
      <p className="text-center py-2">
        <span className="text-primary">
          {data?.fullName} đã gửi yêu cầu theo dõi bạn
        </span>
      </p>
      <div className="flex justify-center w-full gap-4">
        <button
          className="z-10 py-2 px-8 text-white text-[14px] bg-primary__gradient flex rounded-lg items-center"
          onClick={() =>
            acceptFollow({
              req: {
                userId: uid as string,
                isAccepted: true,
              },
              callback: async () => {
                await refectAfterChangeInformation();
              },
            })
          }
        >
          <FiUserPlus className="mr-1" />
          Đồng ý
        </button>
        <button
          className="z-10 px-8 text-red-700 text-[14px] bg-red-100 flex rounded-lg items-center"
          onClick={() =>
            toast.action({
              title: 'Từ chối yêu cầu theo dõi!',
              content: 'Bạn chắc chắn muốn từ chối yêu cầu theo dõi này?',
              onAction: () =>
                acceptFollow({
                  req: {
                    userId: uid as string,
                    isAccepted: false,
                  },
                  callback: async () => {
                    await refectAfterChangeInformation();
                  },
                }),
              actionName: 'Từ chối',
              closeAfterAction: true,
            })
          }
        >
          <BiTrash className="mr-1" />
          Từ chối
        </button>
      </div>
    </div>
  );
};

export default memo(PendingFollowMe);
